import { render, staticRenderFns } from "./PasswordVerifierWidget.vue?vue&type=template&id=2b563af2&"
import script from "./PasswordVerifierWidget.vue?vue&type=script&lang=js&"
export * from "./PasswordVerifierWidget.vue?vue&type=script&lang=js&"
import style0 from "./PasswordVerifierWidget.vue?vue&type=style&index=0&id=2b563af2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports